//@ vendors
const React = require('react');

// @ components
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const listItem = require('./listItem');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { text } = require('components/mortgageRequest/mortgageRequestPanel/mortgageRequestViewProcess/initialValues');


const sectionRelatedProducts = (data) => {

    const { relatedProducts, homeInsuranceEnabled } = data;

    const show = relatedProducts.get('show');
    const homeInsurancePriceClosed = relatedProducts.get('homeInsurancePriceClosed');
    const isFetching = relatedProducts.get('isFetching');

    if (isFetching) {
        return <LoadingSection />;
    }

    if (show) {
        return (
            <div className="mortgage-request-view-process__panel-left-section">
                <OKBoxTitle
                    value={text().SECTION.RELATED_PRODUCTS.TITLE}
                    size="medium"
                />
                {homeInsuranceEnabled && listItem(text().SECTION.RELATED_PRODUCTS.ITEM_INSURANCE_RELATED, homeInsurancePriceClosed)}

            </div>
        )
    }

    return null

}

module.exports = sectionRelatedProducts;